import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Homepage.module.css';

const Homepage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>{t('homepage.title')}</h1>
        <p className={styles.subtitle}>{t('homepage.subtitle')}</p>
        <div className={styles.description}>
          <p>{t('homepage.intro')}</p>
          <ul className={styles.featureList}>
            <li>{t('homepage.featureTimestamp')}</li>
            <li>{t('homepage.featureUrl')}</li>
            <li>{t('homepage.featureStringStats')}</li>
            <li>{t('homepage.featureStringDiff')}</li>
            <li>{t('homepage.featureJson')}</li>
            <li>{t('homepage.featureBase64')}</li>
            <li>{t('homepage.featureHash')}</li>
            <li>{t('homepage.featureJwt')}</li>
            <li>{t('homepage.featureCron')}</li>
            <li>{t('homepage.featureRegex')}</li>
            <li>{t('homepage.featureMore')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Homepage; 